module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.songs.length) ? _c('div', {
    staticClass: "youtube"
  }, [_c('div', {
    staticClass: "youtube__container"
  }, [_c('ul', {
    staticClass: "youtube__list"
  }, _vm._l((_vm.songs), function(song, i) {
    return _c('li', {
      staticClass: "song"
    }, [_c('a', {
      staticClass: "song__delete",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeSong(i, $event)
        }
      }
    }, [_vm._v("×")]), _vm._v(" "), _c('div', {
      staticClass: "song__image"
    }, [_c('img', {
      attrs: {
        "src": song.image,
        "alt": song.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "song__details"
    }, [_c('div', {
      staticClass: "song__title"
    }, [_vm._v(_vm._s(song.name))]), _vm._v(" "), _c('span', {
      staticClass: "song__album"
    }, [_c('span', {
      staticClass: "song__label"
    }, [_vm._v("Album: ")]), _vm._v(" " + _vm._s(song.album))]), _vm._v(" "), _c('div', {
      staticClass: "song__artists"
    }, [_c('span', {
      staticClass: "song__label"
    }, [_vm._v("Artist: ")]), _vm._v(" "), _c('span', {
      staticClass: "song__artist"
    }, [_vm._v("\n                " + _vm._s(song.artists.join(', ')) + "\n              ")])])]), _vm._v(" "), _c('ul', {
      class: {
        'song__youtube': true, 'is-visible': song.videos.length > 0
      }
    }, _vm._l((song.videos), function(video, videoIndex) {
      return _c('li', {
        staticClass: "video"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.v[i]),
          expression: "v[i]"
        }],
        attrs: {
          "type": "radio",
          "id": video.id
        },
        domProps: {
          "value": video.id,
          "checked": _vm._q(_vm.v[i], video.id)
        },
        on: {
          "change": function($event) {
            var $$exp = _vm.v,
              $$idx = i;
            if (!Array.isArray($$exp)) {
              _vm.v[i] = video.id
            } else {
              $$exp.splice($$idx, 1, video.id)
            }
          }
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "video__link",
        attrs: {
          "href": 'https://www.youtube.com/watch?v=' + video.id,
          "target": "_blank"
        }
      }, [_c('img', {
        staticClass: "video__image",
        attrs: {
          "src": video.thumbnail,
          "alt": video.title
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "video__title"
      }, [_vm._v(_vm._s(video.title))])])])
    }))])
  }))])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "action--search",
    class: {
      'is-visible': _vm.songs != undefined && _vm.songs.length > 0 && !_vm.state.searched
    },
    on: {
      "click": _vm.searchOnYoutube
    }
  }, [_vm._v("\n      " + _vm._s((_vm.state.searching) ? 'Searching...' : 'Search on Youtube') + "\n  ")]), _vm._v(" "), _c('div', {
    class: {
      'is-visible': _vm.state.searched, 'action--create': true
    }
  }, [_c('div', {
    staticClass: "create"
  }, [_c('a', {
    staticClass: "create__link",
    on: {
      "click": _vm.createPlaylist
    }
  }, [_vm._v(_vm._s(_vm.state.exported ? 'Playlist created' : 'Create Playlist'))]), _vm._v(" "), (_vm.state.create && !_vm.state.exported) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitPlaylist($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "playlist-name"
    }
  }, [_vm._v("Playlist name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playlist['name']),
      expression: "playlist['name']"
    }],
    staticClass: "create__name",
    attrs: {
      "type": "text",
      "id": "playlist-name"
    },
    domProps: {
      "value": _vm._s(_vm.playlist['name'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        var $$exp = _vm.playlist,
          $$idx = 'name';
        if (!Array.isArray($$exp)) {
          _vm.playlist['name'] = $event.target.value
        } else {
          $$exp.splice($$idx, 1, $event.target.value)
        }
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.songs.length) + " " + _vm._s(_vm.songs.length == 1 ? 'song' : 'songs') + " will be exported.")]), _vm._v(" "), _c('button', {
    staticClass: "create__submit"
  }, [_vm._v("\n          Let's do this!\n          "), _c('span', {
    style: ({
      display: (_vm.state.exporting) ? 'inline-block' : 'none'
    })
  }, [_vm._v(_vm._s(_vm.songsExported + '/' + _vm.songs.length))])])]) : _vm._e(), _vm._v(" "), (_vm.state.exported) ? _c('div', {
    staticClass: "exported"
  }, [_c('p', [_vm._v("Awesome! Your new " + _vm._s(_vm.playlist.title) + " playlist is ready, "), _c('a', {
    attrs: {
      "href": _vm.playlist.url
    }
  }, [_vm._v("check it out!")])]), _vm._v(" "), _c('p', [_vm._v("Thanks for you using it, "), _c('a', {
    attrs: {
      "href": 'https://twitter.com/intent/tweet?text=I created a playlist from Spotify to Youtube, create yours!&hashtags=spotifty,youtube&url=' + encodeURIComponent('http://spotify-youtube.jepser.com'),
      "onclick": "javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;",
      "target": "_blank"
    }
  }, [_vm._v("now spead the word :)")])]), _vm._v(" "), _c('a', {
    staticClass: "exported__button",
    on: {
      "click": _vm.startAgain
    }
  }, [_vm._v("Do you want to create another one?")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20e052ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Youtube.vue
// module id = 51
// module chunks = 0